<template>
  <div class="min-h-screen w-full">
    <slot />
  </div>
</template>

<script setup>
// Public layout for share pages
</script>
